import { HostingEnvironment } from '@opengov/psp-contract';
import { FeatureFlagKey } from '../hooks/useFeatureFlags';
import type { UnresolvedGlobalRegistryEntry } from '../types';

export const globalRegistry: readonly UnresolvedGlobalRegistryEntry[] = [
  {
    id: 'psp-demo-assistant-widget',
    featureFlagKey: FeatureFlagKey.PSP_DEMO_ASSISTANT_WIDGET,
    moduleUrl: (ctx) => {
      switch (ctx.hostingEnvironment) {
        case HostingEnvironment.DEVELOPMENT:
          return 'https://psp-demo-assistant.ogintegration.us/module/widget.js';
        case HostingEnvironment.INTEGRATION:
          return 'https://psp-demo-assistant.ogintegration.us/module/widget.js';
        case HostingEnvironment.STAGING:
          return 'https://psp-demo-assistant.ogstaging.us/module/widget.js';
        case HostingEnvironment.PRODUCTION:
          return 'https://psp-demo-assistant.opengov.com/module/widget.js';
        default:
          return 'https://psp-demo-assistant.ogintegration.us/module/widget.js';
      }
    },
  },
];
